<template>
  <table>
    <slot />
  </table>
</template>
